const organization_details = {
    departments: {
        leader: 'Responsável',
        leaders: 'Responsáveis do departamento',
        led_departments: 'Departamentos sob sua gestão',
        edit_leaders: 'Gerenciar responsáveis',
        add_leader: 'Adicionar',
        remove_leader: 'Remover',
        no_leaders: 'Sem responsáveis',
        local: 'Gestão local',
        managed_members: 'Membros no âmbito de gestão',
        leader_scope_hint: 'Gerencie as atribuições dos seus departamentos e subdepartamentos.',
        leader_permission_hint: 'Responsáveis gerenciam as atribuições dos seus departamentos e subdepartamentos, sem alterar funções ou hierarquias.',
        primary_synced: 'O departamento principal é gerenciado pelo Feishu.',
        status_active: 'Ativo',
        status_suspended: 'Suspenso',
        status_departed: 'Desligado',
        status_pending: 'Ativação pendente',
        search: 'Pesquisar',
        previous_page: 'Página anterior',
        next_page: 'Próxima página',
        directory_title: 'Membros da organização',
        member_name: 'Membro',
        search_members: 'Pesquisar por nome ou usuário',
        include_descendants: 'Incluir subdepartamentos',
        no_members: 'Nenhum membro encontrado.',
        all_members: 'Todos os membros',
        all_departments: 'Todos os departamentos',
        edit_member: 'Editar departamentos',
        add_child: 'Adicionar subdepartamento',
        expand_department: 'Expandir {{name}}',
        collapse_department: 'Recolher {{name}}',
        title: 'Departamentos',
        description: 'Gerencie os departamentos e os vínculos dos membros desta organização.',
        create: 'Criar departamento',
        edit: 'Editar departamento',
        name: 'Nome do departamento',
        parent: 'Departamento superior',
        root: 'Sem departamento superior',
        id: 'ID do departamento',
        members: 'Departamentos dos membros',
        member_id: 'ID de usuário do membro',
        primary: 'Departamento principal',
        none: 'Não definido',
        assignments: 'Vínculos de departamentos',
        no_assignments: 'Ainda não há vínculos de departamentos.',
        assignment_hint: 'Atribua departamentos locais e, opcionalmente, um principal. Os vínculos do diretório são somente leitura.',
        empty: 'Ainda não há departamentos.',
        readonly: 'Você pode ver os departamentos e seus vínculos. Contate um administrador para fazer alterações.',
        load_error: 'Não foi possível carregar os dados. Tente novamente.',
        mutation_error: 'Não foi possível salvar. Verifique permissões, associação e hierarquia dos departamentos.',
        loading: 'Carregando…',
        synced: 'Gerenciado pelo diretório',
        choose: 'Buscar departamentos',
        organizations_title: 'Organizações e departamentos',
        organizations_description: 'Escolha uma organização para ver ou gerenciar seus departamentos.',
        no_organizations: 'Você não pertence a uma organização. Contate um administrador.',
        organization: 'Organização atual',
        choose_organization: 'Escolha uma organização',
        delete_title: 'Excluir departamento',
        delete_description: 'Excluir “{{name}}”? Mova primeiro os membros e subdepartamentos.',
    },
    directory: {
        leaders_label: 'Responsabilidades do departamento',
        local_department_leader: 'Responsável atribuído localmente',
        status_active: 'Ativo',
        status_suspended: 'Suspenso',
        status_departed: 'Desligado',
        status_pending: 'Ativação pendente',
        profiles_label: 'Perfis de origem',
        primary_label: 'Alterações de departamento principal',
        deactivated_label: 'Identidades desativadas',
        reactivated_label: 'Identidades reativadas',
        lifecycle_notice: 'Atribuições de funções mantidas: {{count}}. A reativação restaura as permissões anteriores.',
        title: 'Diretório Feishu',
        description: 'Importe departamentos e membros para esta organização usando um conector Feishu.',
        identity_notice: 'Use um conector com provisionamento de diretório ativado. Alterar a identidade de um conector existente exige migração de contas.',
        connector: 'ID do conector Feishu',
        preview: 'Visualizar sincronização',
        preview_title: 'Prévia da sincronização',
        preview_description: 'Revise o diretório antes de importar. Se houver alterações, gere uma nova prévia.',
        import: 'Confirmar sincronização',
        success: '{{departments}} departamentos e {{users}} membros importados; {{createdUsers}} contas criadas. Removidos {{removedDepartments}} departamentos, {{removedMemberships}} vínculos de organização e {{removedAssignments}} vínculos de departamento.',
        failure: 'Não foi possível ler ou importar o diretório. Verifique permissões e visibilidade do conector e gere outra prévia.',
        behavior_title: 'Modo de importação',
        mode: 'Sincronizar nomes, avatares, departamentos e departamentos principais. Membros ausentes ou inativos perdem acesso somente a esta organização; funções, atribuições locais, contas globais e outras identidades são mantidas. E-mail e telefone são dados de origem, não credenciais de acesso.',
        limits: 'Por importação: 1000 departamentos, 5000 usuários, 10000 vínculos; leitura limitada a 60 segundos. Importações incompletas ou excessivas são rejeitadas.',
        counts: '{{departments}} departamentos · {{users}} membros',
        departments_label: 'Departamentos',
        members_label: 'Vínculos com a organização',
        assignments_label: 'Vínculos de departamento',
        item: 'Item',
        added: 'Adicionar',
        updated: 'Atualizar',
        removed: 'Remover',
        cleanup_notice: 'Sincronizar nomes, avatares, departamentos e departamentos principais. Membros ausentes ou inativos perdem acesso somente a esta organização; funções, atribuições locais, contas globais e outras identidades são mantidas. E-mail e telefone são dados de origem, não credenciais de acesso.',
        conflicts_title: '{{count}} conflitos bloqueiam a sincronização. Resolva as dependências locais e visualize novamente.',
        removals_title: 'Exemplos de remoção (até 20 por categoria)',
        local_child_department: 'Subdepartamento local',
        unowned_assignment: 'Vínculo local ou antigo sem origem comprovada',
        local_member_roles: 'O membro tem funções atribuídas localmente',
        unlinked_identity: 'A identidade do diretório foi desvinculada',
    },
    page_title: 'Detalhes da organização',
    delete_confirmation: 'Uma vez excluída, todos os membros perderão sua associação e cargos nesta organização. Essa ação não pode ser desfeita.',
    organization_id: 'ID da organização',
    settings_description: 'Organizações representam as equipes, clientes empresariais e empresas parceiras que podem acessar suas aplicações.',
    name_placeholder: 'O nome da organização, não é necessário ser único.',
    description_placeholder: 'Uma descrição da organização.',
    member: 'Membro',
    member_other: 'Membros',
    add_members_to_organization: 'Adicionar membros à organização {{name}}',
    add_members_to_organization_description: 'Encontre usuários apropriados pesquisando nome, e-mail, telefone ou ID do usuário. Membros existentes não são mostrados nos resultados da pesquisa.',
    add_with_organization_role: 'Adicionar com função(ões) na organização',
    user: 'Usuário',
    application: 'Aplicação',
    application_other: 'Aplicações',
    add_applications_to_organization: 'Adicionar aplicações à organização {{name}}',
    add_applications_to_organization_description: 'Encontre aplicações apropriadas pesquisando pelo ID do aplicativo, nome ou descrição. Aplicaçōes existentes não são mostradas nos resultados da pesquisa.',
    at_least_one_application: 'Pelo menos uma aplicação é necessária.',
    remove_application_from_organization: 'Remover aplicação da organização',
    remove_application_from_organization_description: 'Uma vez removida, a aplicação perderá sua associação e funções nesta organização. Essa ação não pode ser desfeita.',
    search_application_placeholder: 'Pesquise pelo ID do aplicativo, nome ou descrição',
    roles: 'Funções da organização',
    authorize_to_roles: 'Autorizar {{name}} a acessar os seguintes cargos:',
    edit_organization_roles: 'Editar cargos da organização',
    edit_organization_roles_title: 'Editar cargos da organização de {{name}}',
    remove_user_from_organization: 'Remover usuário da organização',
    remove_user_from_organization_description: 'Uma vez removido, o usuário perderá sua associação e cargos nesta organização. Essa ação não pode ser desfeita.',
    search_user_placeholder: 'Pesquisar por nome, e-mail, telefone ou ID do usuário',
    at_least_one_user: 'Pelo menos um usuário é necessário.',
    organization_roles_tooltip: 'As funções atribuídas ao {{type}} dentro desta organização.',
    custom_data: 'Dados personalizados',
    custom_data_tip: 'Dados personalizados é um objeto JSON que pode ser usado para armazenar dados adicionais associados à organização.',
    invalid_json_object: 'Objeto JSON inválido.',
    branding: {
        name: 'Marca',
        description: 'Personalize a experiência de login em nível de organização.',
        organization_level_sie: 'Experiência de login em nível de organização',
        organization_level_sie_switch: 'Habilite a experiência de login em nível de organização e configure a marca específica da organização. Se desabilitado, fará fallback primeiro para o login em nível de aplicação e depois para a experiência omni.',
        logo: 'Logotipos da organização',
        logo_tooltip: 'Você pode passar o ID da organização para exibir este logotipo na experiência de login; a versão escura do logotipo é necessária se o modo escuro estiver habilitado nas configurações da experiência de login omni. <a>Saiba mais</a>',
    },
    jit: {
        title: 'Provisionamento Just-in-time',
        description: 'Os usuários podem ingressar automaticamente na organização e serem atribuídos a funções na primeira vez que fizerem login através de alguns métodos de autenticação. Você pode definir os requisitos para o provisionamento just-in-time.',
        email_domain: 'Provisionamento de domínio de e-mail',
        email_domain_description: 'Novos usuários que se inscreverem com seus endereços de e-mail verificados ou através do login social com endereços de e-mail verificados ingressarão automaticamente na organização. <a>Saiba mais</a>',
        email_domain_placeholder: 'Digite domínios de e-mail para provisionamento just-in-time',
        invalid_domain: 'Domínio inválido',
        domain_already_added: 'Domínio já adicionado',
        sso_enabled_domain_warning: 'Você inseriu um ou mais domínios de e-mail associados ao SSO empresarial. Usuários com esses e-mails seguirão o fluxo padrão do SSO e não serão provisionados para esta organização, a menos que o provisionamento do SSO empresarial esteja configurado.',
        enterprise_sso: 'Provisionamento SSO empresarial',
        no_enterprise_connector_set: 'Você ainda não configurou nenhum conector de SSO empresarial. Adicione conectores primeiro para habilitar o provisionamento SSO empresarial. <a>Configurar</a>',
        add_enterprise_connector: 'Adicionar conector empresarial',
        enterprise_sso_description: 'Novos usuários ou usuários existentes que fizerem login através de SSO empresarial pela primeira vez ingressarão automaticamente na organização. <a>Saiba mais</a>',
        organization_roles: 'Funções padrão da organização',
        organization_roles_description: 'Atribuir funções aos usuários ao ingressar na organização através do provisionamento just-in-time.',
    },
    mfa: {
        title: 'Autenticação multifator (MFA)',
        tip: 'Quando a MFA é necessária, usuários sem MFA configurada serão rejeitados ao tentar trocar um token da organização. Esta configuração não afeta a autenticação do usuário.',
        description: 'Requerer aos usuários que configurem a autenticação multifator para acessar esta organização.',
        no_mfa_warning: 'Nenhum método de autenticação multifator está habilitado para seu locatário. Os usuários não poderão acessar esta organização até que pelo menos um <a>método de autenticação multifator</a> esteja habilitado.',
    },
};
export default Object.freeze(organization_details);
